<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="topImg bg-contain"></div>
            <div class="list-container">
                <div class="list bh bwrap shadow-bg r10">
                    <div
                        class="list-item"
                        v-for="(item, index) in data"
                        :key="index"
                        @click="go('FeeVipPay',item)"
                    >
                        <div class="item shadow-bg bv bc r10">
                            <div
                                class="img bg-contain"
                                :style="{backgroundImage: `url(${item.iconPic})`}"
                            ></div>
                            <div class="fz_24">{{item.name}}</div>
                            <van-button class="btn btn-mini btn-goodcart btnGo">
                                <span class="fz_24">立即充值</span>
                            </van-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { vipTypeList } from "@/api/fee";
export default {
    name: "FeeVipHome",
    data() {
        return {
            data: []
        };
    },
    created() {
        vipTypeList().then(res => {
            this.data = res.data;
        });
    }
};
</script>

<style scoped lang="scss">
.scrollbar-container {
    background-color: #f7f8f8;
    .r10 {
        @include border-radius(10px);
    }
    .topImg {
        height: 320px;
        background-image: url("~@/assets/imges/fee/vipTop.png");
    }
    .list-container {
        padding: 0 30px 50px 30px;
        margin-top: -60px;
        .list {
            padding: 60px 23px;
            background-color: #fff;
            .list-item {
                flex: 0 0 33.3%;
                .item {
                    margin: 12px 7px;
                    padding: 30px 0;
                    .img {
                        width: 92px;
                        height: 82px;
                        margin-bottom: 11px;
                    }
                    .btnGo {
                        @include border-radius(20px);
                        margin-top: 20px;
                        width: 120px;
                        height: 40px;
                    }
                }
            }
        }
    }
}
[data-theme="app"] {
    .scrollbar-container {
        .topImg {
            background-image: url("~@/assets/imges/app/fee/vipTop.png");
        }
    }
}
</style>